import { Redirect } from 'react-router-dom'

import LazyImport from 'src/HOC/LazyImport'
import WithAuth from 'src/HOC/WithAuth'

const oAuthRoutes: any = [
  {
    path: '/oauth',
    component: (props: any) => {
      const Auth = LazyImport(() => import('src/scenes/Auth'))

      return <Auth oauth {...props} />
      // return WithoutAuth(LazyImport(() => import('src/scenes/Auth')))
    },
    routes: [
      {
        path: '/oauth',
        exact: true,
        component: () => <Redirect to="/oauth/login" />
      },
      {
        path: '/oauth/login',
        exact: true,
        component: (props: any) => {
          const Login = LazyImport(() => import('src/scenes/Auth/scenes/Login'))
          return <Login oauth redirect="/oauth/authorize" {...props} />
        }
      },
      {
        path: '/oauth/forgot-password',
        exact: true,
        component: (props: any) => {
          const ForgotPassword = LazyImport(
            () => import('src/scenes/Auth/scenes/ForgotPassword')
          )
          return <ForgotPassword oauth {...props} />
        }
      },
      {
        path: '/oauth/set-password',
        exact: true,
        component: (props: any) => {
          const SetPassword = LazyImport(
            () => import('src/scenes/Auth/scenes/SetPassword')
          )
          return <SetPassword oauth {...props} />
        }
      },
      {
        path: '/oauth/reset-password',
        exact: true,
        component: (props: any) => {
          const ResetPassword = LazyImport(
            () => import('src/scenes/Auth/scenes/ResetPassword')
          )
          return <ResetPassword oauth {...props} />
        }
      },
      {
        path: '/oauth/authorize',
        exact: true,
        component: (props: any) => {
          const Login = WithAuth(
            LazyImport(() => import('src/scenes/Auth/scenes/Authorize')),
            true
          )

          return <Login oauth {...props} />
        }
      },
      {
        path: '*',
        component: () => <Redirect to="/oauth/login" />
      }
    ]
  },
  {
    path: '/',
    component: WithAuth(
      LazyImport(() => import('src/components/layout/MainLayout')),
      true
    ),
    routes: [
      {
        path: '/not-found',
        component: LazyImport(() => import('src/scenes/NotFound'))
      },
      {
        path: '*',
        component: () => <Redirect to="/not-found" />
      }
    ]
  }
]

export default oAuthRoutes
